import { VStack } from '@chakra-ui/react'
import { FormTextInput } from 'src/components/common/Forms/FormTextInput'
import { InvoiceFormInputs } from './InvoiceEditForm'
import InvoiceEditorSection from './InvoiceEditorSection'

export const InvoiceBasicInformation: React.FC = () => {
  return (
    <InvoiceEditorSection title="基本情報" number={2}>
      <VStack alignItems={'flex-start'} spacing="20px">
        <FormTextInput<InvoiceFormInputs>
          isRequired
          w="160px"
          name="invoice_number"
          label="請求書番号"
          helpTooltipText="請求先から指定がない場合、特に変更する必要はありません！"
        />
        <FormTextInput<InvoiceFormInputs>
          w="320px"
          name="title"
          label="件名"
          placeholder="例）◯◯の件につきまして"
        />
      </VStack>
    </InvoiceEditorSection>
  )
}
